module.exports = __webpack_public_path__ + "images/cov-02-faq-desktop.png";